export const HF_ROUTES = {
  dashboard: '/dashboard',
  stations: '/stations',
  stationEntity: '/stations/:id',
  /** Single-site partners only: the station detail page for their one station. */
  mySite: '/my-site',
  productCatalog: '/product-catalog',
  /** Rebates group parent (no page of its own; the nav opens Rebate Programs). */
  rebates: '/rebates',
  /** Rebate Programs page (MOCK, HF-5487). */
  rebatePrograms: '/rebates/programs',
  /** Suppliers — no page yet (MOCK, HF-5487); the nav item is shown but does not navigate. */
  rebateSuppliers: '/rebates/suppliers',
  sitePerformance: '/site-performance',
  visits: '/visits',
  visitsList: '/visits/list',
  storeTransactions: '/store-transactions',
  /** Transactions list opened with the Product Category chip preset to Fuel + Store. */
  storeTransactionsFuelStore: '/store-transactions/fuel-store',
  /** Transactions list with no preset filter (the "EV Transactions" option). */
  storeTransactionsList: '/store-transactions/list',
  transactions: '/transactions',
  payments: '/payments',
  campaigns: '/campaigns',
  customers: '/customers',
  customerEntity: '/customers/:id',
  people: '/people',
  analytics: '/analytics',
  /** Drill-down from Analytics customer list — query: customerKey, from, to, optional stationId, labelLast4. */
  analyticsCustomerActivity: '/analytics/customer-activity',
  notifications: '/notifications',
  settings: '/settings',
  support: '/support',
  members: '/settings/members',
  accountDetails: '/settings/account-details',
  generalSettings: '/settings/general',
};

export const HF_ROUTES_PATHS = Object.values(HF_ROUTES);
